import React, { useRef, useEffect, useCallback, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import { Text, Heading } from '../../util/typography';
import {
    HeaderContainer as DrawerHeaderContainer,
    Header as DrawerHeader,
    HeaderText as DrawerHeaderText,
} from '../PageHeader';
import * as colors from '../../util/colors';
import { between } from 'polished';
import {
    createLocalScaleFunction,
    hasScrolledPassed,
    once,
    checkAndTriggerCancerTypeChange,
    createMarkup,
} from '../../util/functions';
import { createOverlay } from '../../components/Overlay';
import { createSelector } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import useOnClickOutside from 'use-onclickoutside';
import {
    HAS_DISMISSED_INDICATION_PREVIEW_KEY,
    HAS_SCROLLED_STORAGE_KEY,
} from '../../store/storage-keys';
import { CSSTransition } from 'react-transition-group';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

import {
    allowScrolling,
    preventScrolling,
    openIndicationDrawerPreview,
    minimizeIndicationDrawerPreview,
    toggleIndicationDrawer,
    toggleSafetyDrawer,
    indicateScrolledPastInPageSSI,
    indicateNotScrolledPastInPageSSI,
    openOverlay,
    closeOverlay,
    closeAllMenuItems,
    closeMobileMenu,
    closeFilter,
    toggleQSubIndicationDrawer,
} from '../../store/actions';
import {
    INDICATIONS_AND_SAFETY_CONTAINER,
    INDICATIONS_DRAWER_LAUNCH_BUTTON,
    SAFETY_DRAWER_LAUNCH_BUTTON,
    INDICATIONS_INFORMATION_DRAWER,
    SAFETY_INFORMATION_DRAWER,
    INDICATIONS_AND_SAFETY_DRAWER_OVERLAY,
} from '../../constants/z-index-map';
import icon_plus_small from '../../assets/icon-plus-small.svg';
import icon_close from '../../assets/icon-close.svg';
import IndicationsList from './IndicationsList';
import SafetyList from './SafetyList';
import {default as globalSafetyData} from './data/globalSafety';
import { plusBlueberry, closeBlueberry, closeWhite, plusCloud  } from '../../util/icons';
import { multiTextUnderline } from '../../util/typography/Text';
import BackToTop from '../BackToTop';
import { InformationHead } from './styled';
import qsubSafety from './data/qsubSafety';

const bp = NAVIGATION_BREAKPOINT;

const IndicationPreviewText = `<div>KEYTRUDA and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) are each indicated for the treatment of adult patients with unresectable or metastatic melanoma.</div>`

const LaunchButtonContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    position: fixed;
    width: 100%;
    box-sizing: border-box;
    bottom: 0;
    cursor: pointer;
    max-width: 1032px;
    margin: 0 auto;
    left: 0;
    right: 0;
    padding: 0;
    pointer-events: none;
    transition: transform 0.3s ease-in-out;
    border-radius: 8px 8px 0 0;
    /* @todo Use real transition values for this, not just '300%' */
    transform: ${({ isCollapsed }) => (isCollapsed ? 'translateY(100%)' : 'none')};
    background: transparent;
    margin-bottom: env(safe-area-inset-bottom);
    border-radius: 8px 8px 0 0;
    z-index: ${INDICATIONS_AND_SAFETY_CONTAINER};
    > * {
        pointer-events: auto;
    }

    @media (min-width: ${bp}) {
        bottom:0px;
        padding: 0 20px;
    }
     @media (min-width: 775px) {
        margin-bottom: 0;
    }
`;

const LaunchButton = styled.div`
    border: 1px solid ${colors.silver};
    overflow: hidden;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    background-color: ${colors.white};
    border-radius: 8px 8px 0 0;
    box-sizing: border-box;

    @media (min-width: ${bp}) {
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.16);
        transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
        &:hover {
            box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
        }
    }
 

    header {
        display: flex;
        width: 100%;
        justify-content: space-between;
        // align-items: center;

        &::after {
            content: '';
            height: 20px;
            width: 20px;
            border-radius: 50%;
            background-color: ${colors.mist};
            background-color: none;
            background-image: url(${plusBlueberry});
            background-size: 10px 10px;
            background-repeat: no-repeat;
            background-position: center center;
            border: none;
            color: transparent;
            padding: 0;
            margin: 0px -5px 0 0;
            transition: 0.3s background-color ease-in-out;
        }

        span {
            color: ${colors.blueberry};
            ${multiTextUnderline};
        }
    }

    &:hover header{
        span {
            background-size: 100% 1.1px;
        }
    span {
    color: ${colors.blueberryDark};}
    &::after {
        background-image: url(${plusCloud});
        background-color: ${colors.blueberryDark};
    }}

    > div {
        overflow: hidden;
    }
`;

const PreviewTitle = styled(Text.Button)`
    line-height: 24px;
    font-size: 18px;
    color: ${colors.blueberry};

    // .break {
    // display: ${({qsub})=> qsub ? 'block' :  'inline'};
    // }

`;

const PreviewText = styled(Text.Body)`
    line-height: 20px;
    color: ${colors.charcoal};
    font-weight:300;

    strong {
        font-weight: 400;
    }
    span {
        display: block; 
    }

    @media (max-width: 875px) {

        span {     
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
      }
    }
     
`;

const IndicationsLaunchButton = styled(LaunchButton)`
    // height: ${({ isOpen, drawerName, qsub }) => (isOpen ? (drawerName == 'indications' ? (qsub ? '110px' : '85px') : '130px') : (qsub ?'67px' : '44px'))};
    height: ${({ isOpen, drawerName }) => (isOpen ? (drawerName == 'indications' ? '85px': '130px') : '44px')};
    z-index:  ${INDICATIONS_DRAWER_LAUNCH_BUTTON};
    padding: ${({ isOpen }) => (isOpen ? '10px 0 4px' : '0')};
    margin-bottom: -8px;
    transition: height 0.3s ease-in-out, padding 0.3s ease-in-out;
    display: ${({isDrawerOpen }) => isDrawerOpen ? 'none' : 'block'};

    ${PreviewText} {
    display:  ${({ isOpen }) => (isOpen ? 'block' : 'none')};
     }

    @media (max-width: 675px){
        height: ${({ isOpen, drawerName }) => (isOpen ? (drawerName == 'indications' && '106px') : '44px')};
    }
`;

const SafetyLaunchButton = styled(LaunchButton)`
    height: 156px;
    z-index:  ${SAFETY_DRAWER_LAUNCH_BUTTON};
    // margin-bottom: -5px;
    display: ${({ isDrawerOpen }) => isDrawerOpen ? 'none' : 'block'};
    padding: 7px 0px 4px;

    @media (min-width: 608px) and (max-width: ${bp}) {
        margin-bottom: 0px;
    }
    @media (min-width: 770px) {
        // margin-bottom: -1px;
        height: 115px;
    }
`;


const CloseButton = styled.button`
    flex: none;
    width: 44px;
    height: 44px;
    cursor: pointer;
    background-color: ${colors.mist};

    /* Any value greater than a single side */
    border-radius: 99px;
    background-image: url(${closeBlueberry});
    background-size: 15px 15px;
    background-repeat: no-repeat;
    background-position: center center;
    border: none;
    color: transparent;
    padding: 0;
    margin: 0;
    transition: 0.3s background-color ease-in-out;

    &:hover {
        background-color: ${colors.blueberryDark};
        background-image: url(${closeWhite});
    }
`;

const header_bump_out_padding = 6;
const DrawerSubheaderText = styled(Heading.Subtitle)`
    /* @todo Replace with real color token */
    background: #36864a;

    display: inline-block;
    padding: ${header_bump_out_padding}px 8px;
    border-radius: 4px;
    font-weight: 500;
    color: ${colors.white};
`;

const InformationDrawer = styled.div`
    position: fixed;
    height: 100%;
    overflow: unset;
    top: 100vh;
    left: 0;
    right: 0;
    z-index: 40; 
    transition: 0.4s transform ease-in-out;
    max-width: 1032px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    cursor: default;

    @media (min-width: 1024px){
    ::after{
    content: '';
    position: absolute;
    display:block;
    height: 10px;
    width: calc(100% - 40px);
    background: white;
    z-index: 40; 
    max-width: 992px;
    // bottom: ${({drawerName, qsub}) => drawerName=== 'safety' ? (qsub ? '49px' : '26px') : '86px'};
    bottom: ${({drawerName}) => drawerName === 'safety' ? '26px' : '86px'};    
   }
}


}
 .headContainer{
    background: white;
    padding: 20px 40px 0px;  //change top padding 40 if dual SSI
    position:relative;
    height: auto;
    &.fade-bottom{
    &::after{
        content: '';
        display: block;
        background: linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%);
        width: 97%;
        height: 50px;
        top: 100%;
        left: 0;
        position: absolute;
        transform: translateY(-4px);
    }
    }
    }

    .listCont {
        display: flex;
        // flex-direction: row;
        // gap: 40px;
        background: #FFF;

        h4:nth-child(2){
        @media (max-width: ${bp}){
        display: none;}
        @media (min-width: ${bp}){
                margin-left: -20px;
        }
        }
        
    }

    > .container {
        display: grid;
        // grid-template-columns: ${({drawerName, qsub})=> !qsub ? '1fr' : (drawerName=== 'safety' ? '1fr' : '1fr 1fr')};
        grid-template-columns: 1fr;
        // grid-template-columns: ${({drawerName})=> drawerName === 'safety' ? '1fr' : '1fr 1fr'};
        // flex-direction: row;
        gap: 40px;
        background-color: ${colors.white};
        padding: 20px 40px 20px;

        overflow-y: auto;
        overflow-x: hidden;
        // margin-bottom: ${({drawerName, qsub})=> drawerName === 'safety' ?  (qsub ? '57px': '33px') : '93px'};
        margin-bottom: ${({drawerName})=> drawerName === 'safety' ? '33px' : '95px'};

        >section: nth-child(2) {
        @media (max-width: ${bp}){
        display: none;}
        }

        >section{ 
        footer {
        padding-bottom: calc(3.16% + 29.87px);
        }

        >article:last-child{
        padding-bottom: calc(29.87px + 3.16%);
        }
    }}


    &.information-drawer-enter {
        transform: translateY(0);
        opacity: 1;
        display: flex;
    }

    &.information-drawer-enter-active,
    &.information-drawer-enter-done {
        transform: translateY(-100vh);
        opacity: 1;
        display: flex;
    }

    &.information-drawer-exit {
        transform: translateY(-100vh);
        display: flex;
    }

    &.information-drawer-exit-active,
    &.information-drawer-exit-done {
        transform: translateY(0);
        display: flex;
    }

    &.information-drawer-exit-done {
        opacity: 0;
    }

    /* Override existing styles */
    ${DrawerHeaderContainer} {
        position: relative;
        display: flex;
        flex: none;
        width: 100%;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        align-items: center;
    }

    ${DrawerHeader} {
    // display: flex;
    // justify-content: space-between;
    flex-direction: row;
    flex: 1;
    margin: 0;

        /*
            This seems too clever. But the math checks out! If we want to use media queries,
            we can refactor to that. I'm just wanting to scale between two values, but also calculuate
            those values based on the subheader's inner padding.
        */
        padding-left: clamp(
            ${20 - header_bump_out_padding}px, ${between(`${20 - header_bump_out_padding}px`, `${40 - header_bump_out_padding}px`,'375px','1000px')},
            ${40 - header_bump_out_padding}px);
        padding-right: clamp(
            ${20 - header_bump_out_padding}px, ${between(`${20 - header_bump_out_padding}px`, `${40 - header_bump_out_padding}px`,'375px','1000px')},
            ${40 - header_bump_out_padding}px);
        // padding-right: ${40 - header_bump_out_padding}px;
        padding-top: clamp(20px, 4%, 30px);
        padding-bottom: clamp(20px, 4%, 30px);
    }
    ${DrawerHeaderText} {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: ${header_bump_out_padding}px;
        display: flex;
        align-items: center;

        /* Don't let the text run into the close button */
        padding-right: 35px;

        margin-bottom: 4px;
    }

    ${CloseButton} {
        position: absolute;
        top: 0;
        right: 0;

        /* 4% is between (20/320) and (30/1000), which is what we are scaling between */
        margin-top: clamp(20px, 4%, 30px);
        margin-right: clamp(20px, 4%, 30px);

    }

    @media (min-width: ${bp}) {
        padding: 0 20px;
        display: ${({ mobile }) => !mobile ? 'none' : 'flex'}
    }

    // @media (max-width: 736px) and (min-width: 446px) {
    // > .container {
    //     margin-bottom: ${({drawerName, qsub})=> drawerName === 'safety' && qsub && '53px'};
    //     }
    // }
    
    // @media (max-width: 446px) {
    // > .container {
    //     margin-bottom: ${({drawerName, qsub})=> drawerName === 'safety' && (qsub ?'76px' : '53px')};
    //     }
    // }
    
    @media (max-width: ${bp}) {
    > .container {
        margin-bottom: ${({drawerName})=> drawerName !== 'safety' && '85px'};
        padding: 10px 20px 0;
        grid-template-columns: 1fr;
        }
    .headContainer{
       padding: 20px 20px 0px;
        }
    }

`;

const Columns = styled.div`
  display: grid !important;
// grid-template-columns:  ${({drawerName, qsub})=> !qsub ? '1fr': drawerName === 'indications' ? '1fr 1fr' : '1fr'};
  grid-template-columns: 1fr;
  padding: ${({ isOpen, drawerName }) => drawerName === 'indications' ? isOpen  ? '0' : '7px 0 4px' : 0};


> section {
    //  padding: 7px 20px;
        padding: 0 20px;
}

// &:hover > section > header::after{
//   background-color: ${colors.blueberryDark};
// }

> section: nth-child(2) {
    @media (max-width: ${bp}) {
        display: ${({ mobile }) => !mobile ? 'none' : 'block'};
    }
 }

 @media (max-width: ${bp}) {
   grid-template-columns: 1fr;
}
    
`;

const CloseButtonContainer = styled.div`
display: flex;
align-items: center;
`;

export const STICKY_ISI_OVERLAY_KEY = 'STICKY_ISI';
export const StickyIsiOverlay = createOverlay(STICKY_ISI_OVERLAY_KEY, {
    extendsOverlay: StyledOverlay =>
        styled(StyledOverlay)`
            z-index: ${INDICATIONS_AND_SAFETY_DRAWER_OVERLAY};
        `,
});

const isiDrawerSelector = createSelector(
    state => state.indicationDrawerPreviewOpen,
    state => state.indicationDrawerOpen,
    state => state.safetyDrawerOpen,
    state => state.qSubIndicationDrawerOpen,
    state => state.overlayActive,
    state => state.scrollLock,
    (
        indicationDrawerPreviewOpen,
        indicationDrawerOpen,
        safetyDrawerOpen,
        qSubIndicationDrawerOpen,
        overlayActive,
        scrollLock
    ) => ({
        indicationDrawerPreviewOpen,
        indicationDrawerOpen,
        safetyDrawerOpen,
        qSubIndicationDrawerOpen,
        overlayActive,
        scrollLock,
    })
);

const IndicationAndSafetyDrawer = ({
    inline_indications_ref,
    launch_button_container_ref,
    hcp_acknowledgement_ref,
    safetyDataOverride,
    indicationId, //if there is an indicationId here, it means we are 'filtering the drawer',
    qsub // this is for global indication, change css based on "qsub", if dual SI is required
}) => {
    const { indicationDrawerPreviewOpen, indicationDrawerOpen, safetyDrawerOpen, qSubIndicationDrawerOpen } = useSelector(
        isiDrawerSelector
    );
    let scrolled_passed = useSelector(state => state.scrolledPastInPageSSI);
    const dispatch = useDispatch();


    useEffect(() => {
        let removeInteresctionObserver = hasScrolledPassed({
            element: inline_indications_ref && inline_indications_ref.current,
            scrolledPassedFn: () => {
                console.log('🟢 Scrolled past');
                dispatch(indicateScrolledPastInPageSSI());
            },
            stillBeneathFn: () => {
                console.log('🔴 Still beneath');
                dispatch(indicateNotScrolledPastInPageSSI());
            },
        });

        // On unmount / re-render, remove our interesction observer
        return removeInteresctionObserver;
    }, [inline_indications_ref, dispatch]);

    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight-500;
    
        if (scrollTop === 0) {
            dispatch(indicateNotScrolledPastInPageSSI());             
        }
        if (scrollTop + windowHeight >= docHeight) {
            dispatch(indicateScrolledPastInPageSSI());          
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    /* this was in Matt's orignal branch */

    // We really only want to run this once, even if indicationDrawerPreviewOpen or dispatch change (I think!)
    // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (indicationDrawerPreviewOpen && typeof window !== 'undefined') {
            return once(window, 'scroll', function () {
                // Storage value is only used when redux state is initialized (aka on page refreshes)
                console.log('scrolled');
                window.sessionStorage.setItem(HAS_SCROLLED_STORAGE_KEY, '1');
                dispatch(minimizeIndicationDrawerPreview());
            });
        }
    }, [dispatch, indicationDrawerPreviewOpen]);

    /*end this was in Matt's orignal branch */

    useEffect(() => {
        /**
         * Scroll overflow'd indications content to top before it opens.
         * This is because if we scroll down, close, then reopen, the browser
         * will keep that scroll position.
         */
        indications_scrollable_ref.current.scrollTo(0, 0);
    }, [indicationDrawerPreviewOpen]);

    const setIndicationPreviewSessionToken = useCallback(() => {
        if (typeof window !== 'undefined' && window.origin !== 'null') {
            window.sessionStorage.setItem(HAS_DISMISSED_INDICATION_PREVIEW_KEY, '1');
        }
    }, []);

    const closeIndicationsPreview = useCallback(() => {
        //close the preview state, if it isn't already
        setIndicationPreviewSessionToken();
        dispatch(minimizeIndicationDrawerPreview());
    }, [setIndicationPreviewSessionToken, dispatch]);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.origin !== 'null') {
            let has_dismissed_preview = window.sessionStorage.getItem(
                HAS_DISMISSED_INDICATION_PREVIEW_KEY
            );

            if (!has_dismissed_preview) {
                dispatch(openIndicationDrawerPreview());
                // DISABLED scroll-to-dismiss as it was being triggered by CCPA banner 'hide'
                //if the user hasn't dismissed the preview state of the indications drawer, show it and set up the scroll listener
                // return once(document, 'scroll', function () {
                //     if (!scrollLock) {
                //         closeIndicationsPreview();
                //     }

                // });
            }
        }
    }, [dispatch, closeIndicationsPreview, setIndicationPreviewSessionToken]);

    useEffect(() => {
        //since the indications preview state should only be 'on first page view', set the cookie now so it will not open again this browser session
        setIndicationPreviewSessionToken();
    }, [setIndicationPreviewSessionToken]);

    const indications_scrollable_ref = useRef(null);
    const indications_drawer_ref = useRef(null);
    const indication_launch_button_ref = useRef(null);

    const safety_scrollable_ref = useRef(null);
    const safety_drawer_ref = useRef(null);

    const qSub_launch_button_ref = useRef(null)

    const closeAllHandler = () => {
        closeDrawers();
        dispatch(closeAllMenuItems());
        dispatch(closeMobileMenu());
        dispatch(openOverlay(STICKY_ISI_OVERLAY_KEY));
        dispatch(closeFilter());
        dispatch(preventScrolling());
        closeIndicationsPreview();
        checkAndTriggerCancerTypeChange();
    }
    function fadeBottom(nodeNum){
        
        const fadeElement =  document.querySelectorAll(".headContainer")[nodeNum]
        if(fadeElement.nextSibling.classList.contains("container")){
            fadeElement.nextSibling.addEventListener("scroll",(e)=>{
                if(e.target.scrollTop > 1){                    
                            fadeElement.classList.add("fade-bottom")
                        }else{
                                fadeElement.classList.remove("fade-bottom")
                        }                
            })
           }
    }
    const openIndications = (e) => {
        closeAllHandler();
        dispatch(toggleIndicationDrawer());
        fadeBottom(0)

    };
    const openSafety = (e) => {
        // Similar to scrollable indications, scroll safety content to top
        safety_scrollable_ref.current.scrollTo(0, 0);
        closeAllHandler();
        dispatch(toggleSafetyDrawer());

        //make it 2 if dual SSI
        fadeBottom(1)

    };

    const openQSubIndication = (e) => {
        closeAllHandler();
        dispatch(toggleQSubIndicationDrawer());
        fadeBottom(1)
    }

    const closeDrawers = () => {
        /**
         * @todo create `close` action creators for these
         * e.g. `dispatch(closeIndicationDrawer())` and `dispatch(closeSafetyDrawer())`
         */
        if (indicationDrawerOpen || qSubIndicationDrawerOpen || safetyDrawerOpen) {
            if (indicationDrawerOpen) {
                dispatch(toggleIndicationDrawer());
            }
            if (qSubIndicationDrawerOpen) {
                dispatch(toggleQSubIndicationDrawer());

            }
            if (safetyDrawerOpen) {
                dispatch(toggleSafetyDrawer());

            }
            dispatch(closeOverlay());
            dispatch(allowScrolling());
        }
    };

    useOnClickOutside(indication_launch_button_ref, e => {
        /**
         * If we click on the HCP Acknowledgement bail early.
         */
        if (hcp_acknowledgement_ref?.current?.contains(e.target)) {
            return;
        }

        if (indicationDrawerPreviewOpen) {
            // closeIndicationsPreview();
        }
    });


    /**
     * I want to do extra checks here because otherwise, clicking on the Indications
     * drawer while it is open triggers the clickOutside logic for the Safety Drawer,
     * thus closing everything.
     */
    // useOnClickOutside(indications_drawer_ref, () => {
    //     if (indicationDrawerOpen) {
    //         // closeDrawers();
    //         console.log('indi out')
    //     }
    // });
    // useOnClickOutside(safety_drawer_ref, () => {
    //     if (safetyDrawerOpen) {
    //         // closeDrawers();
    //         console.log('saf out')
    //     }
    // });
    // useOnClickOutside(qSub_drawer_ref, () => {
    //     if (qSubIndicationDrawerOpen) {
    //         // closeDrawers();
    //         console.log('qsub out')
    //     }
    // });

    return (
        <div>
            
            <LaunchButtonContainer ref={launch_button_container_ref} isCollapsed={scrolled_passed}>
                {/* <BackToTop isCollapsed={scrolled_passed}  /> */}
                <IndicationsLaunchButton
                    isOpen={indicationDrawerPreviewOpen}
                    onClick={openIndications}
                    ref={indication_launch_button_ref}
                    data-design-category="indication_vd"
                    isCollapsed={scrolled_passed}
                    mobile={false}
                    isDrawerOpen={indicationDrawerOpen}
                    drawerName="indications"
                    qsub={qsub}
                >
                    <Columns mobile={false} drawerName="indications" isOpen={indicationDrawerPreviewOpen} qsub={qsub}>                        
                          <section>
                            <header>
                                {/* <PreviewTitle qsub={qsub}>KEYTRUDA (pembrolizumab) <span className= 'break'>Selected Indications</span></PreviewTitle> */}
                                <PreviewTitle qsub={qsub}>Selected Indications</PreviewTitle>                           
                            </header>
                            <div>
                                <PreviewText dangerouslySetInnerHTML={{__html: IndicationPreviewText}} />
                            </div>
                        </section>
                          {/* <section>
                            <header>
                                <PreviewTitle>KEYTRUDA QLEX (pembrolizumab +<span className= 'break'> berahyaluronidase alfa-xxxx) Selected Indications</span></PreviewTitle>
                            </header>
                            <div>
                                <PreviewText dangerouslySetInnerHTML={createMarkup(createSubQIndicationPreviewText(indicationId))} />
                            </div>
                        </section> */}
                                               
                    </Columns>
                </IndicationsLaunchButton>

                <CSSTransition
                    in={indicationDrawerOpen}
                    timeout={400}
                    classNames="information-drawer"
                >
                    <InformationDrawer
                        isOpen={indicationDrawerOpen}
                        ref={indications_drawer_ref}
                        drawerName="indications"
                        qsub={qsub}
                    >
                        <DrawerHeaderContainer>
                            <DrawerHeader>
                                <DrawerHeaderText as='h2'>Selected Indications</DrawerHeaderText>
                                {/* <DrawerSubheaderText>
                                    { !qsub ? 'For KEYTRUDA® (pembrolizumab)' : 'For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)'}                                    
                                </DrawerSubheaderText> */}
                                <DrawerSubheaderText>
                                    For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)                                   
                                </DrawerSubheaderText>
                                <CloseButtonContainer>
                                <CloseButton onClick={closeDrawers}>Close</CloseButton>
                                </CloseButtonContainer>                                
                            </DrawerHeader>
                        </DrawerHeaderContainer>
                        <div className="headContainer">
                            <div className="listCont">                               
                                {/* {!qsub ? <InformationHead>For KEYTRUDA (pembrolizumab)</InformationHead> :
                                 <InformationHead>For KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-xxxx)</InformationHead>
                                }          */}
                                {/* <InformationHead>For KEYTRUDA® (pembrolizumab)</InformationHead>  */}
                                {/* <InformationHead>For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)</InformationHead>                                 */}
                            </div>
                        </div>
                        <div className="container" >                            
                           {/* {!qsub ?
                           <IndicationsList
                                columns={2}
                                scrollable_ref={indications_scrollable_ref}
                                indicationId={indicationId}
                                heading="For KEYTRUDA (pembrolizumab)"
                            /> :
                             <QSubIndicationList
                                columns={2}
                                scrollable_ref={indications_scrollable_ref}
                                indicationId={indicationId}
                                heading="For KEYTRUDA QLEX (pembrolizumab and berahyaluronidase alfa-xxxx)"
                            />} */}
                           {/* <IndicationsList
                                columns={2}
                                scrollable_ref={indications_scrollable_ref}
                                indicationId={indicationId}
                                heading="For KEYTRUDA (pembrolizumab)" 
                            /> */}
                             <IndicationsList
                                columns={2}
                                scrollable_ref={indications_scrollable_ref}
                                indicationId={indicationId}
                                heading="For KEYTRUDA QLEX (pembrolizumab and berahyaluronidase alfa-xxxx)"
                            />
                        </div>
                    </InformationDrawer>
                </CSSTransition>

{/* enable when dual SSI */}

               {/* { qsub && <IndicationsLaunchButton
                    isOpen={indicationDrawerPreviewOpen}
                    onClick={openQSubIndication}
                    ref={qSub_launch_button_ref}
                    data-design-category="indication_vd"
                    isCollapsed={scrolled_passed}
                    mobile={true}
                    isDrawerOpen={qSubIndicationDrawerOpen}
                >
                    <Columns drawerName="indications" isOpen={indicationDrawerPreviewOpen}>
                        <section>
                            <header>
                                <PreviewTitle>KEYTRUDA QLEX (pembrolizumab +<br /> berahyaluronidase alfa-xxxx) Selected Indications</PreviewTitle>
                            </header>
                            <div>
                                <PreviewText dangerouslySetInnerHTML={createMarkup(createIndicationPreviewText(indicationId))} />
                            </div>
                        </section>
                    </Columns>
                </IndicationsLaunchButton>
            } */}

                {/* <CSSTransition
                    in={qSubIndicationDrawerOpen}
                    timeout={400}
                    classNames="information-drawer"
                >
                    // Qsub drawer
                    <InformationDrawer
                        isOpen={qSubIndicationDrawerOpen}
                        drawerName="QSubIndication"
                        mobile="true"
                        qsub={qsub}
                    >
                        <DrawerHeaderContainer>
                            <DrawerHeader>
                                <DrawerHeaderText as='h2'>Selected Indications</DrawerHeaderText>
                                    <CloseButtonContainer>
                                        <CloseButton onClick={closeDrawers}>Close</CloseButton>
                                    </CloseButtonContainer>
                            </DrawerHeader>
                        </DrawerHeaderContainer>
                        <div className="headContainer">
                            <div className="listCont">
                                <InformationHead>For KEYTRUDA QLEX (pembrolizumab and berahyaluronidase alfa-xxxx)</InformationHead>
                            </div>
                        </div>
                        <div className="container">
                            <QSubIndicationList
                                columns={2}
                                scrollable_ref={indications_scrollable_ref}
                                indicationId={indicationId}
                                heading="For KEYTRUDA QLEX (pembrolizumab and berahyaluronidase alfa-xxxx)"
                            />
                        </div>
                    </InformationDrawer>
                </CSSTransition> */}

                <SafetyLaunchButton
                    onClick={openSafety}
                    data-design-category="isi_ref_vd"
                    isCollapsed={scrolled_passed}
                    isDrawerOpen={safetyDrawerOpen}
                >
                    <Columns>
                        <section>
                            <header>
                                <PreviewTitle>Selected Safety Information</PreviewTitle>
                            </header>
                            <div>
                                <PreviewText dangerouslySetInnerHTML={{ __html: (safetyDataOverride) ? safetyDataOverride.preview : qsubSafety.preview }} />
                            </div>
                        </section>
                    </Columns>

                </SafetyLaunchButton>

                <CSSTransition in={safetyDrawerOpen} timeout={400} classNames="information-drawer">
                    <InformationDrawer
                        isOpen={safetyDrawerOpen}
                        ref={safety_drawer_ref}
                        drawerName="safety"
                        qsub={qsub}
                    >
                        <DrawerHeaderContainer>
                            <DrawerHeader>
                                <DrawerHeaderText as='h2'>Selected Safety Information</DrawerHeaderText>
                                {/* <DrawerSubheaderText>
                                   {!qsub ? 'For KEYTRUDA® (pembrolizumab)' : 'For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)'}
                                </DrawerSubheaderText> */}
                                <DrawerSubheaderText>
                                  For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)
                                </DrawerSubheaderText>
                                <CloseButtonContainer>
                                   <CloseButton onClick={closeDrawers}>Close</CloseButton>
                                </CloseButtonContainer>
                            </DrawerHeader>
                        </DrawerHeaderContainer>
                        <div className="headContainer">
                            <div className="listCont">
                                {/* <InformationHead> {!qsub ? 'For KEYTRUDA® (pembrolizumab)' : 'For KEYTRUDA® (pembrolizumab) and KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)'}</InformationHead> */}
                            </div>
                        </div>
                        <div className="container">
                            <SafetyList columns={2} scrollable_ref={safety_scrollable_ref} safetyDataOverride={safetyDataOverride} heading="For KEYTRUDA (pembrolizumab)" qsub={qsub} />
                        </div>
                    </InformationDrawer>
                </CSSTransition>
            </LaunchButtonContainer>

            <StickyIsiOverlay onClick={() => closeDrawers()} />
        </div>
    );
};

export default IndicationAndSafetyDrawer;
